export default __webpack_public_path__ + "static/bm-b04bb306c0c8f2e752d95340812f3692.svg";